import qs from 'qs';
import { pickBy } from 'lodash';

import axiosInstance from '../request';
import { pickDevParams } from '../../utils/config';

export const getList = (params) => {
  const parsedParams = pickBy(params);
  return axiosInstance.get('/events/list', { params: { ...parsedParams, ...pickDevParams } });
};

export const markRead = (id) => axiosInstance.post('/events/mark-read', qs.stringify({ id, ...pickDevParams }));

export const markAllRead = () => axiosInstance.post('/events/mark-read-all', qs.stringify(pickDevParams));
